export const appJQueryConfig = () => {
    
    window.$(document).ready(function () {
    // Add body-small class if window less than 768px
    if (window.$(this).width() < 769) {
        window.$('body').addClass('body-small')
    } else {
        window.$('body').removeClass('body-small')
    }

    // MetisMenu
    window.$('#side-menu').metisMenu();

    // Collapse ibox function
    window.$('.collapse-link').on('click', function () {
        console.log(this)
        var ibox = window.$(this).closest('div.ibox');
        var button = window.$(this).find('i');
        var content = ibox.children('.ibox-content');
        content.slideToggle(200);
        button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        setTimeout(function () {
            ibox.resize();
            ibox.find('[id^=map-]').resize();
        }, 50);
    });

    // Close ibox function
    window.$('.close-link').on('click', function () {
        var content = window.$(this).closest('div.ibox');
        content.remove();
    });

    // Fullscreen ibox function
    window.$('.fullscreen-link').on('click', function () {
        var ibox = window.$(this).closest('div.ibox');
        var button = window.$(this).find('i');
        window.$('body').toggleClass('fullscreen-ibox-mode');
        button.toggleClass('fa-expand').toggleClass('fa-compress');
        ibox.toggleClass('fullscreen');
        setTimeout(function () {
            window.$(window).trigger('resize');
        }, 100);
    });

    // Close menu in canvas mode
    window.$('.close-canvas-menu').on('click', function () {
        window.$("body").toggleClass("mini-navbar");
        SmoothlyMenu();
    });

    // Run menu of canvas
    window.$('body.canvas-menu .sidebar-collapse').slimScroll({
        height: '100%',
        railOpacity: 0.9
    });

    // Open close right sidebar
    window.$('.right-sidebar-toggle').on('click', function () {
        window.$('#right-sidebar').toggleClass('sidebar-open');
    });

    // Initialize slimscroll for right sidebar
    window.$('.sidebar-container').slimScroll({
        height: '100%',
        railOpacity: 0.4,
        wheelStep: 10
    });


    // Small todo handler
    window.$('.check-link').on('click', function () {
        var button = window.$(this).find('i');
        var label = window.$(this).next('span');
        button.toggleClass('fa-check-square').toggleClass('fa-square-o');
        label.toggleClass('todo-completed');
        return false;
    });

    // Minimalize menu
    window.$('.navbar-minimalize').on('click', function (event) {
        event.preventDefault();
        window.$("body").toggleClass("mini-navbar");
        SmoothlyMenu();

    });


    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = window.$("body > #wrapper").height() - 61;
        window.$(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarheight = window.$('nav.navbar-default').height();
        var wrapperHeight = window.$('#page-wrapper').height();

        if (navbarheight > wrapperHeight) {
            window.$('#page-wrapper').css("min-height", navbarheight + "px");
        }

        if (navbarheight < wrapperHeight) {
            window.$('#page-wrapper').css("min-height", window.$(window).height() + "px");
        }

        if (window.$('body').hasClass('fixed-nav')) {
            if (navbarheight > wrapperHeight) {
                window.$('#page-wrapper').css("min-height", navbarheight + "px");
            } else {
                window.$('#page-wrapper').css("min-height", window.$(window).height() - 60 + "px");
            }
        }

    }

    fix_height();

    // Fixed Sidebar
    window.$(window).bind("load", function () {
        if (window.$("body").hasClass('fixed-sidebar')) {
            window.$('.sidebar-collapse').slimScroll({
                height: '100%',
                railOpacity: 0.9
            });
        }
    });

    // Move right sidebar top after scroll
    window.$(window).scroll(function () {
        if (window.$(window).scrollTop() > 0 && !window.$('body').hasClass('fixed-nav')) {
            window.$('#right-sidebar').addClass('sidebar-top');
        } else {
            window.$('#right-sidebar').removeClass('sidebar-top');
        }
    });

    window.$(window).bind("load resize scroll", function () {
        if (!window.$("body").hasClass('body-small')) {
            fix_height();
        }
    });

    window.$("[data-toggle=popover]")
        .popover();

    // Add slimscroll to element
    window.$('.full-height-scroll').slimscroll({
        height: '100%'
    })
    });
}


// WEBPACK FOOTER //
// ./src/plugins/jquery/app-config.js